import {createRouter, createWebHistory} from 'vue-router'

const routerHistory = createWebHistory()

// import Vpage from '../view/page.vue'
import Vlogin from '../view/login.vue'
// 定义路由
const routes = [
    {
        path: '/',
        name: 'Vlogin',
        component: Vlogin
    },
   
]

// 创建路由器
const router = createRouter({
    history: routerHistory,
    routes: routes
})

 export default router